import {
  POLLS_COLLECTION,
  POLLS_RESPONSE_COLLECTION,
} from "../../../../AppConstants/CollectionConstants";
import firebase, { firestore } from "../../../../firebase/firebase";

const createResponse = async ({
  userId,
  pollId,
  webinarId,
  agendaId,
  option,
}) => {
  try {
    const respId = `${userId}+${pollId}`;
    let optionIndex = option.id - 1;

    await firestore.runTransaction(async (transaction) => {
      const pollRef = firestore.collection(POLLS_COLLECTION).doc(pollId);
      const docRef = firestore
        .collection(POLLS_RESPONSE_COLLECTION)
        .doc(respId);
      const pollDoc = await transaction.get(pollRef);
      const doc = await transaction.get(docRef);
      if (doc.exists) {
        let err = {
          code: "Already Responded",
          message: "User already responded",
        };
        throw err;
      }

      if (!pollDoc.exists) {
        let err = {
          code: "NotValidId",
          message: "No Poll Found",
        };
        throw err;
      }

      let _option = { ...option };
      delete _option.response;

      transaction.set(docRef, {
        id: respId,
        pollId,
        userId,
        webinarId,
        agendaId,
        option: _option,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      });

      const options = pollDoc.data().options;
      // console.log(options);
      options[optionIndex] = {
        ...options[optionIndex],
        response:
          parseInt(
            options[optionIndex] && options[optionIndex].response
              ? options[optionIndex].response
              : 0
          ) + 1,
      };

      transaction.update(pollRef, {
        options: options,
        totalResponse: firebase.firestore.FieldValue.increment(1),
      });
    });

    return respId;
  } catch (error) {
    console.log("Error :: ", error);
    throw error;
  }
};

const post = {
  createResponse,
};

export default post;
